import { InterviewBatchStatus } from "../../../../utils/constants";

import { convertFirebaseTimestampToDateTimeString } from "../../../../utils/functions/javaScriptHelper";
export const timeSlotModel = {
	date1: {
		date: null,
		dateString: "",
	},
	date2: {
		date: null,
		dateString: "",
	},
	date3: {
		date: null,
		dateString: "",
	},
	date1time1: {
		startTime: null,
		endTime: null,
		startTimeString: "",
		endTimeString: "",
	},
	date2time1: {
		startTime: null,
		endTime: null,
		startTimeString: "",
		endTimeString: "",
	},
	date3time1: {
		startTime: null,
		endTime: null,
		startTimeString: "",
		endTimeString: "",
	},
	date1time2: {
		startTime: null,
		endTime: null,
		startTimeString: "",
		endTimeString: "",
	},
	date2time2: {
		startTime: null,
		endTime: null,
		startTimeString: "",
		endTimeString: "",
	},
	date3time2: {
		startTime: null,
		endTime: null,
		startTimeString: "",
		endTimeString: "",
	},
	date1time3: {
		startTime: null,
		endTime: null,
		startTimeString: "",
		endTimeString: "",
	},
	date2time3: {
		startTime: null,
		endTime: null,
		startTimeString: "",
		endTimeString: "",
	},
	date3time3: {
		startTime: null,
		endTime: null,
		startTimeString: "",
		endTimeString: "",
	},
};

export const prepareTimeslotStructure = (availableTimeslot) => {
	// let timeSlot = { ...timeSlotModel };
	let timeSlot = Object.assign({}, timeSlotModel);

	const day1Data = availableTimeslot.find((ts) => ts.day === 1);
	const day2Data = availableTimeslot.find((ts) => ts.day === 2);
	const day3Data = availableTimeslot.find((ts) => ts.day === 3);

	if (day1Data) {
		timeSlot.date1.dateString = day1Data.date;
	}
	if (day2Data) {
		timeSlot.date2.dateString = day2Data.date;
	}
	if (day3Data) {
		timeSlot.date3.dateString = day3Data.date;
	}

	const date1TimeSlots = day1Data?.timeSlots;
	const date2TimeSlots = day2Data?.timeSlots;
	const date3TimeSlots = day3Data?.timeSlots;

	for (let i = 0; i < 3; i++) {
		if (date1TimeSlots && date1TimeSlots[i]) {
			const timeArray = date1TimeSlots[i].split("~");
			timeSlot[`date1time${i + 1}`].startTimeString = timeArray[0];
			timeSlot[`date1time${i + 1}`].endTimeString = timeArray[1];
		}
		if (date2TimeSlots && date2TimeSlots[i]) {
			const timeArray = date2TimeSlots[i].split("~");
			timeSlot[`date2time${i + 1}`].startTimeString = timeArray[0];
			timeSlot[`date2time${i + 1}`].endTimeString = timeArray[1];
		}
		if (date3TimeSlots && date3TimeSlots[i]) {
			const timeArray = date3TimeSlots[i].split("~");
			timeSlot[`date3time${i + 1}`].startTimeString = timeArray[0];
			timeSlot[`date3time${i + 1}`].endTimeString = timeArray[1];
		}
	}

	return timeSlot;
};

export const prepareTimeslotStructurewithDateTimeStamp = (
	availableTimeslot
) => {
	// let timeSlot = { ...timeSlotModel };
	let timeSlot = Object.assign({}, timeSlotModel);

	const day1Data = availableTimeslot.find((ts) => ts.day === 1);
	const day2Data = availableTimeslot.find((ts) => ts.day === 2);
	const day3Data = availableTimeslot.find((ts) => ts.day === 3);

	if (day1Data) {
		timeSlot.date1.date = day1Data.date;
		timeSlot.date1.dateString = convertFirebaseTimestampToDateTimeString(
			day1Data.date
		);
	}
	if (day2Data) {
		timeSlot.date2.date = day2Data.date;
		timeSlot.date2.dateString = convertFirebaseTimestampToDateTimeString(
			day2Data.date
		);
	}
	if (day3Data) {
		timeSlot.date3.date = day3Data.date;
		timeSlot.date3.dateString = convertFirebaseTimestampToDateTimeString(
			day3Data.date
		);
	}

	const date1TimeSlots = day1Data?.timeSlots;
	const date2TimeSlots = day2Data?.timeSlots;
	const date3TimeSlots = day3Data?.timeSlots;

	for (let i = 0; i < 3; i++) {
		if (date1TimeSlots && date1TimeSlots[i]) {
			const timeArray = date1TimeSlots[i];
			timeSlot[`date1time${i + 1}`].startTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.startTime, "hh:mm");
			timeSlot[`date1time${i + 1}`].endTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.endTime, "hh:mm");
		}
		if (date2TimeSlots && date2TimeSlots[i]) {
			const timeArray = date2TimeSlots[i];
			timeSlot[`date2time${i + 1}`].startTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.startTime, "hh:mm");
			timeSlot[`date2time${i + 1}`].endTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.endTime, "hh:mm");
		}
		if (date3TimeSlots && date3TimeSlots[i]) {
			const timeArray = date3TimeSlots[i];
			timeSlot[`date3time${i + 1}`].startTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.startTime, "hh:mm");
			timeSlot[`date3time${i + 1}`].endTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.endTime, "hh:mm");
		}
	}

	return timeSlot;
};

export const prepareBookedTimeslotStructure = (bookedTimeslot) => {
	// let timeSlot = { ...timeSlotModel };
	let timeSlot = Object.assign({}, timeSlotModel);

	// const day1Data = bookedTimeslot.find((ts) => ts.day === 1);
	// const day2Data = bookedTimeslot.find((ts) => ts.day === 2);
	// const day3Data = bookedTimeslot.find((ts) => ts.day === 3);

	// if (day1Data) {
	// 	timeSlot.date1.dateString = day1Data.date;
	// }
	// if (day2Data) {
	// 	timeSlot.date2.dateString = day2Data.date;
	// }
	// if (day3Data) {
	// 	timeSlot.date3.dateString = day3Data.date;
	// }

	const date1TimeSlots = bookedTimeslot.filter(
		(x) => x.day === 1 && x.bookedBy
	);
	const date2TimeSlots = bookedTimeslot.filter(
		(x) => x.day === 2 && x.bookedBy
	);
	const date3TimeSlots = bookedTimeslot.filter(
		(x) => x.day === 3 && x.bookedBy
	);

	if (date1TimeSlots.length > 0) {
		timeSlot.date1.dateString = date1TimeSlots[0].date;
	}
	if (date2TimeSlots.length > 0) {
		timeSlot.date2.dateString = date2TimeSlots[0].date;
	}
	if (date3TimeSlots.length > 0) {
		timeSlot.date3.dateString = date3TimeSlots[0].date;
	}

	for (let i = 0; i < 3; i++) {
		if (date1TimeSlots && date1TimeSlots[i]) {
			const timeArray = date1TimeSlots[i].slot.split("~");
			timeSlot[`date1time${i + 1}`].startTimeString = timeArray[0];
			timeSlot[`date1time${i + 1}`].endTimeString = timeArray[1];
		}
		if (date2TimeSlots && date2TimeSlots[i]) {
			const timeArray = date2TimeSlots[i].slot.split("~");
			timeSlot[`date2time${i + 1}`].startTimeString = timeArray[0];
			timeSlot[`date2time${i + 1}`].endTimeString = timeArray[1];
		}
		if (date3TimeSlots && date3TimeSlots[i]) {
			const timeArray = date3TimeSlots[i].slot.split("~");
			timeSlot[`date3time${i + 1}`].startTimeString = timeArray[0];
			timeSlot[`date3time${i + 1}`].endTimeString = timeArray[1];
		}
	}

	return timeSlot;
};

export const prepareBookedTimeslotStructureWithDateTimeObject = (
	bookedTimeslot
) => {
	// let timeSlot = { ...timeSlotModel };
	let timeSlot = Object.assign({}, timeSlotModel);

	const date1TimeSlots = bookedTimeslot.filter(
		(x) => x.day === 1 && x.bookedBy
	);
	const date2TimeSlots = bookedTimeslot.filter(
		(x) => x.day === 2 && x.bookedBy
	);
	const date3TimeSlots = bookedTimeslot.filter(
		(x) => x.day === 3 && x.bookedBy
	);

	if (date1TimeSlots.length > 0) {
		timeSlot.date1.dateString = convertFirebaseTimestampToDateTimeString(
			date1TimeSlots[0].date
		);
	}
	if (date2TimeSlots.length > 0) {
		timeSlot.date2.dateString = convertFirebaseTimestampToDateTimeString(
			date2TimeSlots[0].date
		);
	}
	if (date3TimeSlots.length > 0) {
		timeSlot.date3.dateString = convertFirebaseTimestampToDateTimeString(
			date3TimeSlots[0].date
		);
	}

	for (let i = 0; i < 3; i++) {
		if (date1TimeSlots && date1TimeSlots[i]) {
			const timeArray = date1TimeSlots[i].slot;
			timeSlot[`date1time${i + 1}`].startTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.startTime, "hh:mm");
			timeSlot[`date1time${i + 1}`].endTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.endTime, "hh:mm");
		}
		if (date2TimeSlots && date2TimeSlots[i]) {
			const timeArray = date2TimeSlots[i].slot;
			timeSlot[`date2time${i + 1}`].startTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.startTime, "hh:mm");
			timeSlot[`date2time${i + 1}`].endTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.endTime, "hh:mm");
		}
		if (date3TimeSlots && date3TimeSlots[i]) {
			const timeArray = date3TimeSlots[i].slot;
			timeSlot[`date3time${i + 1}`].startTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.startTime, "hh:mm");
			timeSlot[`date3time${i + 1}`].endTimeString =
				convertFirebaseTimestampToDateTimeString(timeArray.endTime, "hh:mm");
		}
	}

	return timeSlot;
};

export const prepareBookedTimeslotStructureWithDateTimeObjectFromAdmin = (
	bookedTimeslot
) => {
	let timeSlot = Object.assign({}, timeSlotModel);

	const sanitizedData = bookedTimeslot.map((slot) => ({
		...slot,
		date: convertFirebaseTimestampToDateTimeString(slot.date),
		startTime: convertFirebaseTimestampToDateTimeString(
			slot.startTime,
			"hh:mm"
		),
		endTime: convertFirebaseTimestampToDateTimeString(slot.endTime, "hh:mm"),
	}));

	const uniqueDates = [...new Set(sanitizedData.map((x) => x.date))];
	if (uniqueDates[0]) {
		timeSlot.date1.dateString = uniqueDates[0];
	} else {
		timeSlot.date1.dateString = "";
	}
	if (uniqueDates[1]) {
		timeSlot.date2.dateString = uniqueDates[1];
	} else {
		timeSlot.date2.dateString = "";
	}
	if (uniqueDates[2]) {
		timeSlot.date3.dateString = uniqueDates[2];
	} else {
		timeSlot.date3.dateString = "";
	}

	const date1TimeSlots = sanitizedData.filter(
		(x) => x.date === timeSlot.date1.dateString
	);
	const date2TimeSlots = sanitizedData.filter(
		(x) => x.date === timeSlot.date2.dateString
	);
	const date3TimeSlots = sanitizedData.filter(
		(x) => x.date === timeSlot.date3.dateString
	);

	for (let i = 0; i < 3; i++) {
		if (date1TimeSlots && date1TimeSlots[i]) {
			timeSlot[`date1time${i + 1}`].startTimeString =
				date1TimeSlots[i].startTime;
			timeSlot[`date1time${i + 1}`].endTimeString = date1TimeSlots[i].endTime;
		} else {
			timeSlot[`date1time${i + 1}`].startTimeString = "";
			timeSlot[`date1time${i + 1}`].endTimeString = "";
		}
		if (date2TimeSlots && date2TimeSlots[i]) {
			timeSlot[`date2time${i + 1}`].startTimeString =
				date2TimeSlots[i].startTime;
			timeSlot[`date2time${i + 1}`].endTimeString = date2TimeSlots[i].endTime;
		} else {
			timeSlot[`date2time${i + 1}`].startTimeString = "";
			timeSlot[`date2time${i + 1}`].endTimeString = "";
		}
		if (date3TimeSlots && date3TimeSlots[i]) {
			timeSlot[`date3time${i + 1}`].startTimeString =
				date3TimeSlots[i].startTime;
			timeSlot[`date3time${i + 1}`].endTimeString = date3TimeSlots[i].endTime;
		} else {
			timeSlot[`date3time${i + 1}`].startTimeString = "";
			timeSlot[`date3time${i + 1}`].endTimeString = "";
		}
	}

	return timeSlot;
};

export const createTimeSlots = (timeSlot) => {
	const {
		date1,
		date2,
		date3,
		date1time1,
		date1time2,
		date1time3,
		date2time1,
		date2time2,
		date2time3,
		date3time1,
		date3time2,
		date3time3,
	} = timeSlot;
	let slotArray = [];

	// Day 1
	if (date1.date) {
		let slotData = {
			day: 1,
			date: date1.dateString,
			timeSlots: [],
		};

		if (date1time1.startTime) {
			slotData.timeSlots.push(
				`${date1time1.startTimeString} ~ ${date1time1.endTimeString}`
			);
		}
		if (date1time2.startTime) {
			slotData.timeSlots.push(
				`${date1time2.startTimeString} ~ ${date1time2.endTimeString}`
			);
		}
		if (date1time3.startTime) {
			slotData.timeSlots.push(
				`${date1time3.startTimeString} ~ ${date1time3.endTimeString}`
			);
		}

		slotArray.push({ ...slotData });
	}

	// Day 2
	if (date2.date) {
		let slotData = {
			day: 2,
			date: date2.dateString,
			timeSlots: [],
		};

		if (date2time1.startTime) {
			slotData.timeSlots.push(
				`${date2time1.startTimeString} ~ ${date2time1.endTimeString}`
			);
		}
		if (date2time2.startTime) {
			slotData.timeSlots.push(
				`${date2time2.startTimeString} ~ ${date2time2.endTimeString}`
			);
		}
		if (date2time3.startTime) {
			slotData.timeSlots.push(
				`${date2time3.startTimeString} ~ ${date2time3.endTimeString}`
			);
		}

		slotArray.push({ ...slotData });
	}

	// Day 3
	if (date3.date) {
		let slotData = {
			day: 3,
			date: date3.dateString,
			timeSlots: [],
		};

		if (date3time1.startTime) {
			slotData.timeSlots.push(
				`${date3time1.startTimeString} ~ ${date3time1.endTimeString}`
			);
		}
		if (date3time2.startTime) {
			slotData.timeSlots.push(
				`${date3time2.startTimeString} ~ ${date3time2.endTimeString}`
			);
		}
		if (date3time3.startTime) {
			slotData.timeSlots.push(
				`${date3time3.startTimeString} ~ ${date3time3.endTimeString}`
			);
		}

		slotArray.push({ ...slotData });
	}

	return slotArray;
};

export const createTimeSlotsWithDateTimeObject = (timeSlot) => {
	const {
		date1,
		date2,
		date3,
		date1time1,
		date1time2,
		date1time3,
		date2time1,
		date2time2,
		date2time3,
		date3time1,
		date3time2,
		date3time3,
	} = timeSlot;
	let slotArray = [];

	// Day 1
	if (date1.date) {
		let slotData = {
			day: 1,
			date: date1.date,
			timeSlots: [],
			dateString: date1.dateString,
		};

		if (date1time1.startTime) {
			slotData.timeSlots.push({
				startTime: date1time1.startTime,
				startTimeString: date1time1.startTimeString,
				endTime: date1time1.endTime,
				endTimeString: date1time1.endTimeString,
			});
		}
		if (date1time2.startTime) {
			slotData.timeSlots.push({
				startTime: date1time2.startTime,
				endTime: date1time2.endTime,
			});
		}
		if (date1time3.startTime) {
			slotData.timeSlots.push({
				startTime: date1time3.startTime,
				endTime: date1time3.endTime,
			});
		}

		slotArray.push({ ...slotData });
	}

	// Day 2
	if (date2.date) {
		let slotData = {
			day: 2,
			date: date2.date,
			timeSlots: [],
		};

		if (date2time1.startTime) {
			slotData.timeSlots.push({
				startTime: date2time1.startTime,
				endTime: date2time1.endTime,
			});
		}
		if (date2time2.startTime) {
			slotData.timeSlots.push({
				startTime: date2time2.startTime,
				endTime: date2time2.endTime,
			});
		}
		if (date2time3.startTime) {
			slotData.timeSlots.push({
				startTime: date2time3.startTime,
				endTime: date2time3.endTime,
			});
		}

		slotArray.push({ ...slotData });
	}

	// Day 3
	if (date3.date) {
		let slotData = {
			day: 3,
			date: date3.date,
			timeSlots: [],
		};

		if (date3time1.startTime) {
			slotData.timeSlots.push({
				startTime: date3time1.startTime,
				endTime: date3time1.endTime,
			});
		}
		if (date3time2.startTime) {
			slotData.timeSlots.push({
				startTime: date3time2.startTime,
				endTime: date3time2.endTime,
			});
		}
		if (date3time3.startTime) {
			slotData.timeSlots.push({
				startTime: date3time3.startTime,
				endTime: date3time3.endTime,
			});
		}

		slotArray.push({ ...slotData });
	}

	return slotArray;
};

export const selectionSteps = [
	{
		title: "Step 1",
		description: "internship_selectStudent_pageStepDescription_step1",
	},
	{
		title: "Step 2",
		description: "internship_selectStudent_pageStepDescription_step2",
	},
	{
		title: "Step 3",
		description: "internship_selectStudent_pageStepDescription_step3",
	},
	{
		title: "Step 4",
		description: "internship_selectStudent_pageStepDescription_step4",
	},
];

export const getAcceptedInterviewSlot = (currentInterviewBatch, studentId) => {
	if (
		!currentInterviewBatch ||
		!currentInterviewBatch.current ||
		(currentInterviewBatch.current &&
			currentInterviewBatch.status === InterviewBatchStatus.InterviewSlotGiven)
	) {
		return null;
	}

	const availableTimeslots = currentInterviewBatch.slotsProposedByAdmin;
	const found = availableTimeslots.find((slot) => slot.bookedBy === studentId);
	return found
		? `${convertFirebaseTimestampToDateTimeString(
				found.date
		  )} - ${convertFirebaseTimestampToDateTimeString(
				found.slot.startTime,
				"hh:mm"
		  )} ~ ${convertFirebaseTimestampToDateTimeString(
				found.slot.endTime,
				"hh:mm"
		  )}`
		: null;
};

export const getAcceptedInterviewSlotFromAdmin = (
	studentsSelectedForInterview,
	studentId
) => {
	// if (
	// 	!currentInterviewBatch ||
	// 	!currentInterviewBatch.current ||
	// 	(currentInterviewBatch.current &&
	// 		currentInterviewBatch.status === InterviewBatchStatus.InterviewSlotGiven)
	// ) {
	// 	return null;
	// }

	// const availableTimeslots = currentInterviewBatch.slotsProposedByAdmin;
	// console.log("studentsSelectedForInterview=>", studentsSelectedForInterview);
	const found = studentsSelectedForInterview.find(
		(stu) => stu.studentId === studentId
	);
	// return found && found.interviewStartTime
	// 	? `${convertFirebaseTimestampToDateTimeString(
	// 			found.interviewStartTime
	// 	  )} - ${convertFirebaseTimestampToDateTimeString(
	// 			found.interviewStartTime,
	// 			"hh:mm"
	// 	  )} ~ ${convertFirebaseTimestampToDateTimeString(
	// 			found.interviewEndTime,
	// 			"hh:mm"
	// 	  )}`
	// 	: null;

	return found && found.interviewSlots
		? `${convertFirebaseTimestampToDateTimeString(
				found.interviewSlots[0].startTime,
				"mm/dd"
		  )} - ${convertFirebaseTimestampToDateTimeString(
				found.interviewSlots[0].startTime,
				"hh:mm"
		  )} ~ `
		: null;
};

export const getStudentDataAddedWithProjectPreference = (
	selectedStudents,
	taggedStudentData
) => {
	if (
		!selectedStudents ||
		!taggedStudentData ||
		selectedStudents.length === 0 ||
		taggedStudentData.length === 0
	) {
		return [];
	}
	const selectedStudentIds = selectedStudents.map((x) => x.id);
	let studentWithProjectData = [];
	let studentWithProjectAndInterviewCountData = [];

	taggedStudentData.forEach((stu) => {
		if (selectedStudentIds.some((x) => x === stu.studentId)) {
			studentWithProjectData.push({
				...stu,
			});
		}
	});

	studentWithProjectData.forEach((stu) => {
		const found = selectedStudents.find((x) => x.id === stu.studentId);
		if (found) {
			studentWithProjectAndInterviewCountData.push({
				...stu,
				noOfInterviewRequested: found.noOfInterviewRequested,
			});
		}
	});

	return studentWithProjectAndInterviewCountData;
};
